import { requestService } from '../';

export const updateUserPassword = async (token: string, newPassword: string) => {
	const { data } = await requestService.put(`/entities/user/password`, { body: { token, password: newPassword } });
	return data;
};
